export const reSplitAlphaNumeric = /([0-9]+)/gm;

/**
 * Comparer function for the natural sort. Based on @tanstack/react-table with few fixes.
 * @param aStr
 * @param bStr
 * @returns comparison results
 */
export const compareAlphanumeric = (aStr: string, bStr: string) => {
    // Split on number groups, but keep the delimiter
    // Then remove falsy split values
    const a = aStr.split(reSplitAlphaNumeric).filter(Boolean);
    const b = bStr.split(reSplitAlphaNumeric).filter(Boolean);

    // While
    while (a.length && b.length) {
        const aa = a.shift()!;
        const bb = b.shift()!;

        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);

        // There is a string. Either one of the elements or both
        if (isNaN(an) || isNaN(bn)) {
            if (aa > bb) {
                return 1;
            }
            if (bb > aa) {
                return -1;
            }
            continue;
        }

        // Both are numbers
        if (an > bn) {
            return 1;
        }
        if (bn > an) {
            return -1;
        }
    }

    return a.length - b.length;
};
